module.exports = __webpack_public_path__ + "static/coin-balance-27a89e57029aee9db284c82cf681bd08.png";